<template>
  <!-- :actions="actionsDD" -->
  <custom-result
    :is-open="isChangeStatus"
    :has-icon-expand="!isChangeStatus"
    :actions="actionsDD"
    :left-color="getColor(option.appointmentStatusCd)"
    :status-name="option.appointmentStatusName | removeParenthesis"
    :cols="3"
    :rows="2"
    @action="clickDD"
  >
    <template #status_bottom>
      <div
        class="status_bottom d-flex flex-column ml-4 mt-3 justify-content-center"
      >
        <div>
          <span>{{ option.formatedClientAppointmentId }}</span>
        </div>
        <div class="clearfix" />
        <div>
          <span>{{ option.appointment_EvaluationType }}</span>
          <p class="font-weight-normal">
            {{ option.appointment_DisciplineName }}
          </p>
        </div>
      </div>
    </template>

    <template #board_information>
      <div class="row ml-2 info">
        <div class="col-sm-6 col-md-4 data pb-3">
          <span>Fecha Cita:</span>
          <p>{{ option.appointmentDate }}</p>
        </div>

        <div class="col-sm-6 col-md-4 data">
          <span>Horario:</span>
          <!--$formatDate(date, $templateDate.hour)-->
          <p>{{ option.appointmentHour }}</p>
        </div>

        <div class="col-sm-6 col-md-4 data">
          <span>Especialista:</span>
          <p>{{ option.specialist_NameFull }}</p>
        </div>

        <div class="col-sm-6 col-md-4 data">
          <span>Nombre:</span>
          <p>{{ option.client_NameFull }}</p>
        </div>

        <div class="col-sm-6 col-md-4 data">
          <span>SIE:</span>
          <p>{{ option.client_SieId }}</p>
        </div>

        <div class="col-sm-6 col-md-4 data">
          <span>Centro:</span>
          <p>{{ option.coordinatedByCenterName }}</p>
        </div>
      </div>
    </template>

    <template v-if="!isChangeStatus" #board_details>
      <div class="w-100 pl-3 pt-4 details">
        <div class="row">
          <div class="col-sm">
            <em class="fas fa-info-circle text-orange" />
            <span class="ml-2">Información del Adicional</span>
          </div>
        </div>
        <div class="clearfix" />
        <div class="row mt-3">
          <div class="col-sm-12 col-md-3 data">
            <span class="font-weight-normal">Proveedor:</span>
            <p>{{ option.companyName }}</p>
          </div>
          <div class="col-sm-12 col-md-5 data">
            <span class="font-weight-normal">Lugar de Servicio:</span>
            <p>{{ option.locationName }}</p>
            <span class="font-weight-normal">Dirección:</span>
            <p v-if="option.locationAddress">
              {{
                option.locationAddress.addressLine1 +
                  ", " +
                  option.locationAddress.addressLine2 +
                  ", " +
                  option.locationAddress.addressLine3
              }}
            </p>
            <span class="font-weight-normal">Teléfono:</span>
            <p>
              {{
                option.locationTelephoneNo != undefined
                  ? formatPhoneNumber(
                      option.locationTelephoneNo,
                      "###-###-####"
                    )
                  : ""
              }}
            </p>
          </div>
          <div class="col-sm-12 col-md-4 data">
            <span class="font-weight-normal">Coordinado por:</span>
            <p>
              {{ option.appointmentCoordinatedBy }} -
              {{ option.appointmentStatusDateCreate }}
            </p>
          </div>
        </div>
        <div class="clearfix" />
        <div class="row">
          <div class="col-sm-12 data">
            <span class="font-weight-normal mb-2">Comentario:</span>
            <p>{{ option.appointmentStatusComment }}</p>
          </div>
        </div>
      </div>
    </template>
    <template v-else #board_details>
      <div class="w-100 p-3">
        <div class="w-100">
          <em class="fas text-orange" :class="changePropsStatus.icon" />
          <span class="ml-2">{{ changePropsStatus.actionStatusName }}</span>
        </div>
        <validation-observer ref="validator">
          <div class="d-flex flex-direction mt-3 w-100">
            <validation-provider
              v-if="statusTo != statuses.coordinated"
              v-slot="{ errors }"
              class="flex-grow-1 gap"
              rules="required"
            >
              <custom-drop-down
                v-model="changePropsStatus.reason"
                label="Razón:"
                :error="errors[0]"
                :custom-error-msg="messages['0675']"
                :options="changePropsStatus.reasons"
                placeholder="Seleccionar"
                fieldkey="id"
                fieldname="name"
                @input="onReasonSelected"
              />
            </validation-provider>

            <validation-provider
              v-if="showReasonDetails"
              v-slot="{ errors }"
              class="flex-grow-2 gap"
              rules="required"
            >
              <custom-drop-down
                v-model="changePropsStatus.reasonDetail"
                label="Detalle:"
                :error="errors[0]"
                :custom-error-msg="messages['0675']"
                :options="changePropsStatus.reasonDetails"
                placeholder="Seleccionar"
                fieldkey="id"
                fieldname="name"
              />
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              class="flex-grow-2"
              rules="required"
            >
              <div>
                <label class="input-label">Comentario:</label>
                <custom-input
                  v-model="changePropsStatus.comment"
                  :error="errors[0]"
                  :custom-error-msg="messages['0675']"
                  maxlength="500"
                  type="text"
                />
              </div>
            </validation-provider>
          </div>
        </validation-observer>
        <div class="d-flex justify-content-end mt-4">
          <action-button
            variant="danger mr-2"
            i="fas fa-times-circle"
            text="Cancelar"
            @click="dispose"
          />
          <action-button
            v-if="isBtnSave"
            variant="success"
            text="Guardar"
            @click="changePropsStatus.save"
          />
          <action-button
            v-else
            variant="success"
            text="Continuar"
            @click="cancelCoordinated"
          />
        </div>
      </div>
    </template>
  </custom-result>
</template>

<script>
import { CustomResult } from "@/components/common/FilterCustomManager";
import alert from "@/mixin/alert.mixin";
import CustomDropDown from "@/components/common/CustomDropDown";
import CustomInput from "@/components/common/CustomInput";
import { ActionButton } from "@/components/common";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import statusEnum from "@/utils/constants/student/appointmentStatusEnum";
import services from "@/services/api";
import DocumentsService from "@/services/documents";
import statusColorMixin from "./statusColor";
import storeMixin from "@/mixin/storeGenerator";

export default {
  name: "RowAppointment",
  mixins: [alert, statusColorMixin, storeMixin],
  components: {
    CustomResult,
    CustomDropDown,
    CustomInput,
    ActionButton,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    messages: {
      type: [Object, Array],
      default: () => []
    },
    position: {
      type: Number,
      required: true
    },
    allowedPilotPlanUser: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      moduleName: "appointmentModule",
      option: this.options,
      isChangeStatus: false,
      changePropsStatus: {
        actionStatusName: "",
        icon: "",
        reasons: [],
        reasonDetails: [],
        reason: null,
        reasonDetail: null,
        comment: null,
        save: () => {}
      },
      collections: {
        reasonsCancelled: [],
        reasonsDenied: []
      },
      statusTo: null,
      statuses: statusEnum
    };
  },
  computed: {
    hasCancelPermissionForDenied() {
      return this.$store.getters.HasPermission(
        "student.appointment.cancelinstatusdenied"
      );
    },
    hasCancelPermission() {
      if (!this.allowedPilotPlanUser) {
        return false;
      }
      return this.$store.getters.HasPermission("appointment.cancel");
    },
    hasConfirmPermission() {
      if (!this.allowedPilotPlanUser) {
        return false;
      }
      return this.$store.getters.HasPermission("appointment.confirm");
    },
    hasDenyPermission() {
      if (!this.allowedPilotPlanUser) {
        return false;
      }
      return this.$store.getters.HasPermission("appointment.deny");
    },
    hasReCoordinatePermission() {
      return this.$store.getters.HasPermission("appointment.recoordinate");
    },
    actionsDD() {
      return [
        {
          Title: "Confirmar Cita",
          Icon: "fas fa-calendar-check",
          IconColor: "text-green",
          Type: "Menu",
          Item: 1,
          Visible:
            this.option.appointmentStatusCd == statusEnum.completed &&
            this.hasConfirmPermission,
          EmitGo: "option",
          Children: []
        },
        {
          Title: "Cancelar Cita",
          Icon: "fas fa-calendar-times",
          IconColor: "text-red",
          Type: "Menu",
          Item: 2,
          Visible:
            (this.option.appointmentStatusCd == statusEnum.coordinated &&
              this.hasCancelPermission) ||
            (this.option.appointmentStatusCd == statusEnum.denied &&
              this.hasCancelPermissionForDenied),
          EmitGo: "option",
          Children: []
        },
        {
          Title: "Denegar Cita",
          Icon: "fas fa-times-square",
          IconColor: "text-red",
          Type: "Menu",
          Item: 3,
          EmitGo: "option",
          Visible:
            this.isConfirmAccionVisible(this.option.appointmentStatusCd) &&
            this.hasDenyPermission,
          Children: []
        },
        {
          Title: "Documentos Anejados",
          Icon: "fas fa-file-download",
          IconColor: "text-green",
          Type: "Menu",
          Item: 4,
          EmitGo: "option",
          Visible:
            this.option.appointmentStatusCd == statusEnum.completed ||
            this.option.appointmentStatusCd == statusEnum.confirmed ||
            this.option.appointmentStatusCd == statusEnum.denied,
          Children: []
        },
        {
          Title: "Cambiar a Coordinada",
          Icon: "fas fa-redo",
          IconColor: "text-green",
          Type: "Menu",
          Item: 5,
          EmitGo: "option",
          Visible:
            (this.option.appointmentStatusCd == statusEnum.cancelled_De ||
              this.option.appointmentStatusCd == statusEnum.cancelled_Prov) &&
            this.hasReCoordinatePermission,
          Children: []
        },
        {
          Title: "Historial de Cita",
          Icon: "fas fa-history",
          IconColor: "text-green",
          Type: "Menu",
          Item: 6,
          EmitGo: "option",
          Visible: true,
          Children: []
        }
      ];
    },
    params() {
      return {
        statusComment: this.changePropsStatus.comment,
        appointmentStatusReasonCd: this.changePropsStatus.reason
          ? this.changePropsStatus.reason.id
          : null,
        appointmentStatusCd: this.statusTo,
        clientAppointmentId: this.option.clientAppointmentId,
        inactivateRegStudent: null,
        appointmentStatusReasonDetailCd: this.changePropsStatus.reasonDetail?.id
      };
    },
    isBtnSave() {
      if (this.changePropsStatus.reason == null) {
        return true;
      }
      return this.changePropsStatus.reason.id != 6;
    },
    showReasonDetails() {
      let validReasonsToDetail = [
        7,
        8
      ]; /* Cancelada/No asistieron y Cancelada/No se logró cordinar */

      if (
        this.statusTo == this.statuses.cancelled_De &&
        validReasonsToDetail.indexOf(this.changePropsStatus.reason?.id) > -1
      )
        return true;

      return false;
    }
  },
  methods: {
    async clickDD(item) {
      this.$store.commit(
        "setShowEditionCallaout",
        !this.$store.state.showEditionCallaout
      );
      
      switch (item) {
        case 1:
          await this.confirmAction();
          break;
        case 2:
        await this.cancelAction();
          break;
        case 3:
        await this.deniedAction();
          break;
        case 4:
        await this.downloadEvaluationDocumentAction();
          break;
        case 5:
        await this.reCoordinate();
          break;
        case 6:
          this.$router.push({
            name: "HistoricalAppointmentManagement",
            params: {
              client: this.params.clientAppointmentId
            }
          });
          break;
      }
      this.$emit("getCoordinations");
    },
    async cancelCoordinated() {
      const isValid = await this.$refs.validator.validate();
      if (!isValid) return;

      this.persistLazyData({
        studentSie: this.option.client_SieId,
        comment: this.changePropsStatus.comment,
        disciplineTypeId: this.option.disciplineTypeCd,
        serviceTypeId: this.option.appointment_ServiceTypeCd,
        cancelAppointmentId: this.option.clientAppointmentId,
        appoinmentCancelAction: this.params
      });

      this.$router.push({
        name: "AppoinmentCoordination"
      });
    },
    isConfirmAccionVisible(status) {
      if (status == statusEnum.completed) {
        return true;
      } else if (
        status == statusEnum.confirmed &&
        this.$store.getters.HasPermission(
          "appointment.candenyconfirmedappointments"
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    async confirmAction(args = {}) {
      const response = await this.ShowCancelModal(
        this.messages["R90020"] || "Aviso",
        this.messages["0019"] ||
          "¿Está seguro que desea confirmar que la información en esta Evaluación está correcta?"
      );

      if (response) {
        this.statusTo = statusEnum.confirmed;
        await this.$ApiPost("/api/appointment/confirmappointment", {
          ...this.params,
          ...args
        })
          .then(async res => {
            if (res && res.data) {
              this.ShowToast(
                "Completado",
                "Su información ha sido completada exitosamente.",
                this.toastType.Success
              );
              this.option = {
                ...this.option,
                appointmentStatusCd: statusEnum.confirmed,
                appointmentStatusName: "Confirmada"
              };
              await this.$store.dispatch("AfterConfirmAppoinmentAction");
            }
          })
          .catch(err => {
            if (err && err.response && err.response.data) {
              this.ShowToast("Error", err.response.data.message, "error");
            } else {
              this.ShowToast(
                "Error",
                "Ha ocurrido un error inesperado.",
                "error"
              );
            }
          });
      }
    },
    async cancelAction() {
      const response = await this.ShowCancelModal(
        this.messages["R90020"] || "Aviso",
        this.messages["R90021"] || "¿Está seguro que desea cancelar la cita?"
      );

      if (response) {
        if (this.collections.reasonsCancelled.length == 0) {
          this.statusTo = statusEnum.cancelled_De;
          let reasons = await services.getReasonsApointmentStatus(
            this.statusTo
          );
          this.collections.reasonsCancelled = reasons.data;
        }

        this.changePropsStatus.reasons = this.collections.reasonsCancelled;

        this.isChangeStatus = true;
        this.changePropsStatus = {
          ...this.changePropsStatus,
          actionStatusName: "Razón de Cancelación",
          icon: "fa-file-times",
          save: this.doCancelRequest
        };
      }
    },
    async reCoordinate() {
      const response = await this.ShowCancelModal(
        this.messages["R90020"] || "Aviso",
        this.messages["R90021"] ||
          "¿Está seguro que desea Re-Coordinar la cita?"
      );

      if (response) {
        this.statusTo = statusEnum.coordinated;

        this.isChangeStatus = true;
        this.changePropsStatus = {
          ...this.changePropsStatus,
          actionStatusName: "Razón de ReCoordinación",
          icon: "fa-file-times",
          save: this.doReCoordinate
        };
      }
    },
    async deniedAction(args = {}) {
      if (this.collections.reasonsDenied.length == 0) {
        this.statusTo = statusEnum.denied;
        let reasons = await services.getReasonsApointmentStatus(this.statusTo);
        this.collections.reasonsDenied = reasons.data;
      }

      await this.$ApiPost("/api/appointment/validatesubmittedinvoice", {
        ...this.params,
        ...args
      }).then(async res => {
        if (res && res.data) {
          if (res.data.message != null && res.data.isValid) {
            const response = await this.ShowCancelModal(
              "Aviso",
              res.data.message,
              "Continuar",
              "Cancelar"
            );
            if (response) {
              this.changePropsStatus.reasons = this.collections.reasonsDenied;
              this.isChangeStatus = true;
              this.changePropsStatus = {
                ...this.changePropsStatus,
                actionStatusName: "Denegar Referido",
                icon: "fa-times-square",
                save: this.doDeniedRequest
              };
            } else {
              this.dispose();
            }
          } else if (res.data.message == null && res.data.isValid) {
            this.changePropsStatus.reasons = this.collections.reasonsDenied;
            this.isChangeStatus = true;
            this.changePropsStatus = {
              ...this.changePropsStatus,
              actionStatusName: "Denegar Referido",
              icon: "fa-times-square",
              save: this.doDeniedRequest
            };
          } else if (res.data.message != null && !res.data.isValid) {
            this.ShowToast("Error", res.data.message, this.toastType.Error);
            this.dispose();
          } else {
            this.ShowToast(
              "Error",
              "No se pudo denegar la cita.",
              this.toastType.Error
            );
            this.dispose();
          }
        }
      });
      
    },
    async cancelRequest() {
      return this.$ApiPost("/api/appointment/cancelappointment", {
        ...this.params
      });
    },
    async doCancelRequest() {
      const isValid = await this.$refs.validator.validate();
      if (!isValid) return;

      await this.cancelRequest().then(async res => {
        if (res && res.data) {
          this.ShowToast(
            "Completado",
            "Su información ha sido completada exitosamente.",
            this.toastType.Success
          );
          this.option = {
            ...this.option,
            appointmentStatusCd: statusEnum.cancelled_De,
            appointmentStatusName: "Cancelada(DE)"
          };
          this.dispose();
        }
      });
    },
    async doReCoordinate() {
      const isValid = await this.$refs.validator.validate();
      if (!isValid) return;

      await this.$ApiPost("/api/appointment/recoordinateappointment", {
        ...this.params
      })
        .then(() => {
          this.ShowToast(
            "Completado",
            "Su información ha sido procesada exitosamente.",
            this.toastType.Success
          );
          this.option = {
            ...this.option,
            appointmentStatusCd: statusEnum.coordinated,
            appointmentStatusName: "Coordinada"
          };
          this.isChangeStatus = false;
          this.changePropsStatus.comment = "";
        })
        .catch(err => {
          if (err && err.response && err.response.data) {
            this.ShowToast("Error", err.response.data.message, "error");
          } else {
            this.ShowToast(
              "Error",
              "Ha ocurrido un error inesperado.",
              "error"
            );
          }
        });
    },
    async doDeniedRequest(args = {}) {
      const isValid = await this.$refs.validator.validate();
      if (!isValid) return;

      const response = await this.ShowCancelModal(
        this.messages["R90020"] || "Aviso",
        this.messages["R90022"] ||
          "¿Está seguro que desea Denegar esta Evaluación?"
      );

      if (response) {
        await this.$ApiPost("/api/appointment/deniedappointment", {
          ...this.params,
          ...args
        }).then(async res => {
          if (res && res.data) {
            this.ShowToast(
              "Completado",
              "Su información ha sido completada exitosamente.",
              this.toastType.Success
            );
            this.option = {
              ...this.option,
              appointmentStatusCd: statusEnum.denied,
              appointmentStatusName: "Denegada"
            };
            this.dispose();
          }
        });
      }
    },
    async downloadEvaluationDocumentAction() {
      let clientAppointmentId = parseInt(
        this.option.formatedClientAppointmentId.replace("-", "")
      );

      await this.$ApiGet(`/appointment/documents/${clientAppointmentId}`).then(
        async res => {
          if (res && res.data) {
            for (let i = 0; i < res.data.length; i++) {
              const currentDocument = res.data[i];

              DocumentsService.Download(currentDocument);
            }

            this.dispose();
          }
        }
      );
    },
    formatPhoneNumber(value, pattern) {
      let i = 0,
        v = value.toString();
      return pattern.replace(/#/g, () => v[i++]);
    },
    dispose() {
      this.isChangeStatus = false;
      this.changePropsStatus = {
        actionStatusName: "",
        icon: "",
        reasons: [],
        reasonDetails: [],
        reason: null,
        reasonDetail: null,
        comment: null,
        save: () => {}
      };
    },
    async onReasonSelected() {
      if (this.showReasonDetails) {
        let details = await services.getStatusReasonDetails(
          this.changePropsStatus.reason.id
        );
        this.changePropsStatus.reasonDetails = details.data;
      } else {
        this.changePropsStatus.reasonDetails = [];
        this.changePropsStatus.reasonDetail = null;
      }
    }
  },
  filters: {
    removeParenthesis(status) {
      if (status.includes("(") && status.includes(")")) {
        let idxOpend = status.indexOf("(");
        let idxClosed = status.indexOf(")");
        let nwStatus = `${status.substr(0, idxOpend)} - ${status.substring(
          idxOpend + 1,
          idxClosed
        )}`;
        return nwStatus;
      }
      return status;
    }
  },
  watch: {
    options(nw) {
      this.option = nw;
    },
    "$store.state.showEditionCallaout": function() {
      this.isChangeStatus = false;
    }
  }
};
</script>

<style scoped>
.data span {
  color: #727272;
}
.fsi {
  font-size: 26px;
  color: #3f5b60;
  cursor: pointer;
}
.icon-green {
  color: #2db782;
}
.with-border {
  border-right: 1px solid #727272;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: #b7c7bf;
}
.dropdown-item .cursor-pointer {
  border-bottom: 1px solid #e2e2e2;
}
.edition-title {
  color: #3f5b60;
}

.gap {
  margin-right: 3%;
}

.info .data {
  padding-left: 10px;
}

.info .data span {
  font-size: 14px;
  font-weight: 400;
}

.info .data p {
  font-size: 16px;
  color: black;
  font-weight: 500;
}

.details .data {
  padding-left: 2.5rem !important;
}

.details .data span {
  font-size: 14px;
}

.details .data p {
  margin-top: 5px;
}

.status_bottom > div {
  padding-bottom: 5px;
}

.status_bottom span,
.status_bottom p {
  color: black;
}

@media screen and (max-width: 576px) {
  .info .data {
    margin-left: 2rem;
  }
}

@media screen and (max-width: 650px) {
  .status_bottom {
    margin-top: 5%;
    margin-left: 3rem !important;
  }
}

@media screen and (max-width: 600px) {
  .flex-direction {
    flex-direction: column;
  }

  .gap {
    margin-right: 0;
  }
}
</style>
